import { useState } from "react";
import { useSearchParams } from "react-router-dom";

const SPORTS = new Set([
  "cricket",
  "soccer",
  "tennis",
  "esoccer",
  "basketball",
  "virtualt10",
]);

function sportFromSearch(value: string | null): string {
  const sport = (value || "").toLowerCase();
  return SPORTS.has(sport) ? sport : "cricket";
}

/** Selected sport tab, restored from ?sport= so a refresh or back navigation stays on Tennis (etc.). */
export function useSportTab() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [tab, setTabState] = useState(() => sportFromSearch(searchParams.get("sport")));

  const setTab = (next: string) => {
    const sport = sportFromSearch(next);
    setTabState(sport);
    const params = new URLSearchParams(searchParams);
    if (params.get("sport") === sport) return;
    params.set("sport", sport);
    setSearchParams(params, { replace: true });
  };

  return [tab, setTab] as const;
}
